import React from "react"
import Layout from "../layouts/Layout"
import Header from "../components/Header"
import EventCard from "../components/EventCard"
import BlogCard from "../components/BlogCard"
// import * as styles from "../styles/home.module.css"
import { graphql } from "gatsby"

export default function Home({ data }) {
  const eventsObj = data.events.nodes
  const blogsObj = data.blogs.nodes
  console.log(data)
  console.log(
    "eventsObj",
    eventsObj.filter(e => e.frontmatter.type === "completed")
  )
  return (
    <Layout>
      <Header
        heading={"BE INNOVATIVE . BE DIFFERENT"}
        subHeading={"Advancing Through Technology"}
      ></Header>

      <section className="section about">
        <h1 className="heading">About ACM PCCOER</h1>
        <p className="paragraph">
          PCCOER ACM Student Chapter has been founded for the technical
          development of students in the field of computing. The Chapter
          provides a platform for students to showcase their talents. It
          facilitates community and individual growth in the computing
          profession. The Chapter organizes a number of events, seminars, talks,
          and workshops for its members. It aims to promote Computer Science
          culture.
        </p>
      </section>

      <div className="seperator"></div>

      <section className="section">
        <h1 className="heading">Events</h1>
        <h3 className="sub-heading">Upcoming</h3>
        <div className="container">
          {eventsObj
            .filter(e => e.frontmatter.type === "upcoming")
            .map(event => (
              <EventCard
                title={event.frontmatter.title}
                date={event.frontmatter.date}
                speakers={event.frontmatter.speakers}
                slug={event.frontmatter.slug}
                thumb={event.frontmatter.thumb.childImageSharp.fluid}
              />
            ))}
        </div>
        <h3 className="sub-heading">Latest</h3>
        <div className="container">
          {eventsObj
            .filter(e => e.frontmatter.type === "latest")
            .map(event => (
              <EventCard
                title={event.frontmatter.title}
                date={event.frontmatter.date}
                speakers={event.frontmatter.speakers}
                slug={event.frontmatter.slug}
                thumb={event.frontmatter.thumb.childImageSharp.fluid}
              />
            ))}
        </div>

        <h3 className="sub-heading">Completed</h3>
        <div className="container">
          {eventsObj
            .filter(e => e.frontmatter.type === "completed")
            .map(event => (
              <EventCard
                title={event.frontmatter.title}
                date={event.frontmatter.date}
                speakers={event.frontmatter.speakers}
                slug={event.frontmatter.slug}
                thumb={event.frontmatter.thumb.childImageSharp.fluid}
              />
            ))}
        </div>
      </section>

      <div className="seperator"></div>

      <section>
        <h1 className="heading">Blogs</h1>
        <div className="container blog">
          {blogsObj.map(event => (
            <BlogCard
              title={event.frontmatter.title}
              author={event.frontmatter.author}
              slug={event.frontmatter.slug}
              thumb={event.frontmatter.thumb.childImageSharp.fluid}
            />
          ))}
        </div>
      </section>

      <div className="seperator"></div>
      {/* <br/><br/><br/><br/> */}
    </Layout>
  )
}

export const queries = graphql`
  query HomeQueries {
    events: allMarkdownRemark(
      sort: { order: DESC, fields: frontmatter___sortBy }
      filter: { fileAbsolutePath: { regex: "/(events)/" } }
    ) {
      nodes {
        frontmatter {
          title
          date
          speakers
          slug
          type
          thumb {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    blogs: allMarkdownRemark(
      sort: { order: ASC, fields: frontmatter___sortBy }
      filter: { fileAbsolutePath: { regex: "/(blogs)/" } }
    ) {
      nodes {
        frontmatter {
          title
          date
          speakers
          slug
          author
          thumb {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
